import { BsChevronLeft, BsChevronRight } from "react-icons/bs";

import { cn } from "@/lib/utils";
import { useDataContext } from "../../app/_context";

type SkipButtonPlaylistItem = {
  poster?: string | null;
};

type SkipButtonProps = {
  playlist?: SkipButtonPlaylistItem[];
  currentIndex?: number;
  onClick?: () => void;
};

export function PlayNextButton({
  playlist,
  currentIndex,
  onClick,
}: SkipButtonProps = {}) {
  const {
    currentPlaylist,
    currentSessionIndex,
    startNextSession,
    isBusinessCardPlaying,
  } = useDataContext();
  const visiblePlaylist = playlist ?? currentPlaylist;
  const visibleIndex = currentIndex ?? currentSessionIndex;
  const handleClick = onClick ?? startNextSession;

  if (visiblePlaylist.length > 1)
    return (
      <div
        className={cn(
          isBusinessCardPlaying && "opacity-0 pointer-events-none",
          "dark:text-stone-200 text-stone-800 flex place-items-center w-12"
        )}
      >
        <BsChevronRight
          size={34}
          onClick={handleClick}
          style={{
            opacity: visibleIndex + 1 === visiblePlaylist.length ? 0.3 : 1,
            cursor:
              visibleIndex + 1 === visiblePlaylist.length ? "default" : "pointer",
          }}
          className="arrows ChevronRight"
        />
      </div>
    );
  else
    return (
      <div
        className={cn(
          "dark:text-stone-200 text-stone-800 flex place-items-center w-12"
        )}
      />
    );
}

export function PlayPreviousButton({
  currentIndex,
  onClick,
}: Pick<SkipButtonProps, "currentIndex" | "onClick"> = {}) {
  const {
    currentSessionIndex,
    startPreviousSession,
    isHighlightsOnlyMode,
    firstIndexWithHighlights,
    isBusinessCardPlaying,
  } = useDataContext();
  const visibleIndex = currentIndex ?? currentSessionIndex;
  const handleClick = onClick ?? startPreviousSession;

  return (
    <div
      className={cn(
        isBusinessCardPlaying && "opacity-0 pointer-events-none",
        "dark:text-stone-200 text-stone-800 flex items-center w-12 justify-center"
      )}
    >
      <BsChevronLeft
        size={34}
        className="arrows ChevronLeft"
        style={{
          opacity:
            visibleIndex === 0 ||
            (isHighlightsOnlyMode &&
              firstIndexWithHighlights === visibleIndex)
              ? 0
              : 1,
          cursor: visibleIndex === 0 ? "default" : "pointer",
        }}
        onClick={handleClick}
      />
    </div>
  );
}
